export const PERMISSIONS_SYSTEM_CODE = {
  ORDER_FOLLOW_UP_SIDEBAR: 'ORDER_FOLLOW_UP_SIDEBAR',
  ORDER_FOLLOW_UP_VIEW: 'ORDER_FOLLOW_UP_VIEW',
  ORDER_FOLLOW_UP_CREATE: 'ORDER_FOLLOW_UP_CREATE',
  ORDER_FOLLOW_UP_UPDATE: 'ORDER_FOLLOW_UP_UPDATE',
  ORDER_FOLLOW_UP_DELETE: 'ORDER_FOLLOW_UP_DELETE',
  ORDER_FOLLOW_UP_PROCESS: 'ORDER_FOLLOW_UP_PROCESS',
  ORDER_FOLLOW_UP_DETAILS_VIEW: 'ORDER_FOLLOW_UP_DETAILS_VIEW',
  EVENT_SIDEBAR: 'EVENT_SIDEBAR',
  EVENT_VIEW: 'EVENT_VIEW',
  EVENT_DETAILS_VIEW: 'EVENT_DETAILS_VIEW',
  EVENT_CREATE: 'EVENT_CREATE',
  EVENT_UPDATE: 'EVENT_UPDATE',
  EVENT_DELETE: 'EVENT_DELETE',
  EVENT_INVITES_TAB_VIEW: 'EVENT_INVITES_TAB_VIEW',
  CONTACT_VIEW: 'CONTACT_VIEW',
  CONTACT_DETAILS_VIEW: 'CONTACT_DETAILS_VIEW',
  CONTACT_CREATE: 'CONTACT_CREATE',
  CONTACT_UPDATE: 'CONTACT_UPDATE',
  CONTACT_DELETE: 'CONTACT_DELETE',
  CONTACT_SIDEBAR: 'CONTACT_SIDEBAR',
  CONTACT_IMPORT: 'CONTACT_IMPORT',
  CONTACT_IMPORT_V2: 'CONTACT_IMPORT_V2',
  CONTACT_EXPORT: 'CONTACT_EXPORT',
  CONTACTS_MERGE: 'CONTACTS_MERGE',
  CONTACT_MERGE_UNDO: 'CONTACT_MERGE_UNDO',
  CONTACTS_BULK_MERGE_ADMIN: 'CONTACTS_BULK_MERGE_ADMIN',
  CONTACTS_LIST_VIEW_DISPLAY_COMPANY_COLUMN: 'CONTACTS_LIST_VIEW_DISPLAY_COMPANY_COLUMN',
  CONTACTS_LIST_VIEW_DISPLAY_IS_CUSTOMER_ICON: 'CONTACTS_LIST_VIEW_DISPLAY_IS_CUSTOMER_ICON',
  // CON-1532 — V2 Tabs and Pages. EVENT_GUESTS_TAB_V2 was previously
  // GUESTS_TAB_V2 (renamed in 20260522235530-v2-tabs-and-pages-schema-and-permissions.js).
  // Gates the V2 component trees that read column config via
  // pagePreferencesService.resolvePagePreferences. Seeded isActive=false
  // for every userRole — Chris flips per-user for the beta cohort.
  EVENT_GUESTS_TAB_V2: 'EVENT_GUESTS_TAB_V2',
  GROUP_CONTACTS_TAB_V2: 'GROUP_CONTACTS_TAB_V2',
  CONTACTS_PAGE_V2: 'CONTACTS_PAGE_V2',
  CONTACTS_FILTER_BY_COMPANY: 'CONTACTS_FILTER_BY_COMPANY',
  CONTACTS_FILTER_BY_EVENTS: 'CONTACTS_FILTER_BY_EVENTS',
  CONTACTS_FILTER_BY_LOCATION: 'CONTACTS_FILTER_BY_LOCATION',
  CONTACTS_FILTER_BY_TEXT_HISTORY: 'CONTACTS_FILTER_BY_TEXT_HISTORY',
  CONTACT_CATEGORIES_VIEW: 'CONTACT_CATEGORIES_VIEW',
  CONTACT_CATEGORIES_ADD: 'CONTACT_CATEGORIES_ADD',
  CONTACT_CATEGORIES_DELETE: 'CONTACT_CATEGORIES_DELETE',
  // Gates the Booking / Joining kebab item on Connections + Contact detail
  // (frontend visibility only; seeded isActive=false for every role).
  CONTACT_BOOKING_JOINING: 'CONTACT_BOOKING_JOINING',
  ORDER_FOLLOW_UP_SETTINGS_SIDEBAR: 'ORDER_FOLLOW_UP_SETTINGS_SIDEBAR',
  ORDER_FOLLOW_UP_SETTINGS_VIEW_AND_CRUD: 'ORDER_FOLLOW_UP_SETTINGS_VIEW_AND_CRUD',
  MESSAGE_TEMPLATES_SIDEBAR: 'MESSAGE_TEMPLATES_SIDEBAR',
  MESSAGE_TEMPLATES_VIEW_AND_CRUD: 'MESSAGE_TEMPLATES_VIEW_AND_CRUD',
  EVENTS_SETTINGS_VIEW: 'EVENTS_SETTINGS_VIEW',
  EVENTS_SETTINGS_DETAILS_VIEW: 'EVENTS_SETTINGS_DETAILS_VIEW',
  EVENTS_SETTINGS_SIDEBAR: 'EVENTS_SETTINGS_SIDEBAR',
  EVENTS_SETTINGS_CREATE: 'EVENTS_SETTINGS_CREATE',
  EVENTS_SETTINGS_UPDATE: 'EVENTS_SETTINGS_UPDATE',
  EVENT_GUESTS_LIST_VIEW_DISPLAY_COMPANY_COLUMN: 'EVENT_GUESTS_LIST_VIEW_DISPLAY_COMPANY_COLUMN',
  ACCOUNT_GENERAL_SETTINGS_SIDEBAR: 'ACCOUNT_GENERAL_SETTINGS_SIDEBAR',
  ACCOUNT_GENERAL_SETTINGS_YOUR_INFO: 'ACCOUNT_GENERAL_SETTINGS_YOUR_INFO',
  ACCOUNT_GENERAL_SETTINGS_CAMPAIGNS_TAGS: 'ACCOUNT_GENERAL_SETTINGS_CAMPAIGNS_TAGS',
  ACCOUNT_GENERAL_SETTINGS_OTHER: 'ACCOUNT_GENERAL_SETTINGS_OTHER',
  ACCOUNT_GENERAL_SETTINGS_PB_CUSTOM_FIELDS: 'ACCOUNT_GENERAL_SETTINGS_PB_CUSTOM_FIELDS',
  ACCOUNT_GENERAL_SETTINGS_SUBSCRIPTION: 'ACCOUNT_GENERAL_SETTINGS_SUBSCRIPTION',
  ACCOUNT_GENERAL_SETTINGS_TCR: 'ACCOUNT_GENERAL_SETTINGS_TCR',
  ACCOUNT_GENERAL_SETTINGS_PHONE_NUMBER_PORT: 'ACCOUNT_GENERAL_SETTINGS_PHONE_NUMBER_PORT',
  ACCOUNT_GENERAL_SETTINGS_PASSWORD: 'ACCOUNT_GENERAL_SETTINGS_PASSWORD',
  HELP_INFORMATION_SIDEBAR: 'HELP_INFORMATION_SIDEBAR',
  HELP_INFORMATION_VIEW: 'HELP_INFORMATION_VIEW',
  DAILY_TEXT_USAGE_SIDEBAR: 'DAILY_TEXT_USAGE_SIDEBAR',
  YOUR_CP_PHONE_NUMBER_SIDEBAR: 'YOUR_CP_PHONE_NUMBER_SIDEBAR',
  YOUR_REFERRAL_CODE_SIDEBAR: 'YOUR_REFERRAL_CODE_SIDEBAR',
  CHAT_SIDEBAR: 'CHAT_SIDEBAR',
  CHAT_VIEW: 'CHAT_VIEW',
  CHAT_MESSAGE_CREATE: 'CHAT_MESSAGE_CREATE',
  CHAT_MESSAGE_UPDATE: 'CHAT_MESSAGE_UPDATE',
  CHAT_MESSAGE_DELETE: 'CHAT_MESSAGE_DELETE',
  CONTACT_SETTINGS_SIDEBAR: 'CONTACT_SETTINGS_SIDEBAR',
  CONTACT_SETTINGS_VIEW: 'CONTACT_SETTINGS_VIEW',
  CONTACT_SETTINGS_CATEGORIES_VIEW: 'CONTACT_SETTINGS_CATEGORIES_VIEW',
  CONTACT_SETTINGS_CATEGORIES_DETAILS_VIEW: 'CONTACT_SETTINGS_CATEGORIES_DETAILS_VIEW',
  CONTACT_SETTINGS_CATEGORIES_CREATE: 'CONTACT_SETTINGS_CATEGORIES_CREATE',
  CONTACT_SETTINGS_CATEGORIES_UPDATE: 'CONTACT_SETTINGS_CATEGORIES_UPDATE',
  CONTACT_SETTINGS_CATEGORIES_DELETE: 'CONTACT_SETTINGS_CATEGORIES_DELETE',
  SCHEDULED_MESSAGES_SIDEBAR: 'SCHEDULED_MESSAGES_SIDEBAR',
  SCHEDULED_MESSAGES_VIEW: 'SCHEDULED_MESSAGES_VIEW',
  SCHEDULED_MESSAGES_CREATE: 'SCHEDULED_MESSAGES_CREATE',
  SCHEDULED_MESSAGES_EDIT: 'SCHEDULED_MESSAGES_EDIT',
  MESSAGE_SETTINGS_SIDEBAR: 'MESSAGE_SETTINGS_SIDEBAR',
  MESSAGE_SETTINGS_VIEW: 'MESSAGE_SETTINGS_VIEW',
  MESSAGE_SETTINGS_KEYWORDS_VIEW: 'KEYWORDS_VIEW',
  MESSAGE_SETTINGS_KEYWORDS_EDIT: 'KEYWORDS_EDIT',
  MESSAGE_SETTINGS_KEYWORDS_MANUALLY_EXECUTE: 'KEYWORDS_MANUALLY_EXECUTE',
  GROUP_SETTINGS_SIDEBAR: 'GROUP_SETTINGS_SIDEBAR',
  GROUP_SETTINGS_VIEW: 'GROUP_SETTINGS_VIEW',
  GROUP_SETTINGS_DETAILS_VIEW: 'GROUP_SETTINGS_DETAILS_VIEW',
  GROUP_SETTINGS_CREATE: 'GROUP_SETTINGS_CREATE',
  GROUP_SETTINGS_UPDATE: 'GROUP_SETTINGS_UPDATE',
  GROUP_SETTINGS_DELETE: 'GROUP_SETTINGS_DELETE',
  GROUP_SIDEBAR: 'GROUP_SIDEBAR',
  GROUP_VIEW: 'GROUP_VIEW',
  GROUP_DETAILS_VIEW: 'GROUP_DETAILS_VIEW',
  GROUP_CREATE: 'GROUP_CREATE',
  GROUP_UPDATE: 'GROUP_UPDATE',
  GROUP_DELETE: 'GROUP_DELETE',
  GROUP_CONTACTS_VIEW: 'GROUP_CONTACTS_VIEW',
  GROUP_CONTACTS_ADD: 'GROUP_CONTACTS_ADD',
  GROUP_CONTACTS_REMOVE: 'GROUP_CONTACTS_REMOVE',
  GROUP_CONTACTS_REMOVE_BULK: 'GROUP_CONTACTS_REMOVE_BULK',
  GROUP_SMART_ACTIONS_DO_NOT_EXECUTE: 'GROUP_SMART_ACTIONS_DO_NOT_EXECUTE',
  GROUP_SMART_ACTIONS_VIEW: 'GROUP_SMART_ACTIONS_VIEW',
  GROUP_SMART_ACTIONS_CREATE: 'GROUP_SMART_ACTIONS_CREATE',
  GROUP_SMART_ACTIONS_UPDATE: 'GROUP_SMART_ACTIONS_UPDATE',
  GROUP_SMART_ACTIONS_DELETE: 'GROUP_SMART_ACTIONS_DELETE',
  CP_VOICE_CALLING_SETTINGS: 'CP_VOICE_CALLING_SETTINGS',
  CP_VOICE_CALLING_ACCESS: 'CP_VOICE_CALLING_ACCESS',
  SMART_FIELDS_SIDEBAR: 'SMART_FIELDS_VIEW',
  SMART_FIELDS_VIEW: 'SMART_FIELDS_VIEW',
  SMART_FIELDS_EDIT: 'SMART_FIELDS_EDIT',
  SMART_FIELDS_MANAGE_DEFINITIONS: 'SMART_FIELDS_MANAGE_DEFINITIONS',
  BIRTHDAY_MESSAGE_SETTINGS_VIEW: 'BIRTHDAY_MESSAGE_SETTINGS_VIEW',
  BIRTHDAY_MESSAGE_SETTINGS_UPDATE: 'BIRTHDAY_MESSAGE_SETTINGS_UPDATE',
  BIRTHDAY_MESSAGE_CONTACT_VIEW: 'BIRTHDAY_MESSAGE_CONTACT_VIEW',
  BIRTHDAY_MESSAGE_CONTACT_UPDATE: 'BIRTHDAY_MESSAGE_CONTACT_UPDATE',
  SCHEDULED_CONNECTION_FILTER_BY_BIRTHDAY_MESSAGE: 'SCHEDULED_CONNECTION_FILTER_BY_BIRTHDAY_MESSAGE',
  // Custom Fields Permissions - Group Settings (GroupType)
  GROUP_SETTINGS_CUSTOM_FIELDS_VIEW: 'GROUP_SETTINGS_CUSTOM_FIELDS_VIEW',
  GROUP_SETTINGS_CUSTOM_FIELDS_EDIT: 'GROUP_SETTINGS_CUSTOM_FIELDS_EDIT',
  GROUP_SETTINGS_CUSTOM_FIELDS_MANAGE: 'GROUP_SETTINGS_CUSTOM_FIELDS_MANAGE',
  // Custom Fields Permissions - Group Instance
  GROUP_CUSTOM_FIELDS_VIEW: 'GROUP_CUSTOM_FIELDS_VIEW',
  GROUP_CUSTOM_FIELDS_EDIT: 'GROUP_CUSTOM_FIELDS_EDIT',
  GROUP_CUSTOM_FIELDS_MANAGE: 'GROUP_CUSTOM_FIELDS_MANAGE',
  // Custom Fields Permissions - Event Settings (PartyType)
  EVENTS_SETTINGS_CUSTOM_FIELDS_VIEW: 'EVENTS_SETTINGS_CUSTOM_FIELDS_VIEW',
  EVENTS_SETTINGS_CUSTOM_FIELDS_EDIT: 'EVENTS_SETTINGS_CUSTOM_FIELDS_EDIT',
  EVENTS_SETTINGS_CUSTOM_FIELDS_MANAGE: 'EVENTS_SETTINGS_CUSTOM_FIELDS_MANAGE',
  // Custom Fields Permissions - Event Instance (Party)
  EVENT_CUSTOM_FIELDS_VIEW: 'EVENT_CUSTOM_FIELDS_VIEW',
  EVENT_CUSTOM_FIELDS_EDIT: 'EVENT_CUSTOM_FIELDS_EDIT',
  EVENT_CUSTOM_FIELDS_MANAGE: 'EVENT_CUSTOM_FIELDS_MANAGE',
  // Smart Links Permissions
  SMART_LINKS_SIDEBAR: 'SMART_LINKS_SIDEBAR',
  SMART_LINKS_VIEW: 'SMART_LINKS_VIEW',
  SMART_LINKS_CREATE: 'SMART_LINKS_CREATE',
  SMART_LINKS_UPDATE: 'SMART_LINKS_UPDATE',
  SMART_LINKS_DELETE: 'SMART_LINKS_DELETE',
  SMART_LINKS_DIRECT_REDIRECT: 'SMART_LINKS_DIRECT_REDIRECT',
  // Smart Forms Permissions
  SMART_FORMS_SIDEBAR: 'SMART_FORMS_SIDEBAR',
  SMART_FORMS_VIEW: 'FORMS_V2',
  SMART_FORMS_CREATE: 'FORMS_V2',
  // CON-1545 — Event Smart Actions via Action Rules. Gates the action-rules
  // UI on the Event SA detail/create page + the implicit-convert path.
  SMART_ACTIONS_ACTION_RULES: 'SMART_ACTIONS_ACTION_RULES',
  // Gates the Smart Form builder's Action Rules tab; held to the beta cohort
  // while FORMS_V2 goes wide.
  SMART_FORMS_ACTION_RULES: 'SMART_FORMS_ACTION_RULES',
  // Gates the Smart Form builder's Entries tab (entry list + bulk attach,
  // which writes member tables and can fire join actions); beta cohort.
  SMART_FORMS_ENTRIES: 'SMART_FORMS_ENTRIES',
  // Export Results button on the Entries tab (CSV of the current filtered
  // view, emailed). Granted per-user.
  SMART_FORMS_ENTRIES_EXPORT: 'SMART_FORMS_ENTRIES_EXPORT',
  // CON-XXXX — Activity badges: "new since you last looked" counts (new
  // Smart Form entries on the sidebar, the list and the Entries tab). Each
  // area also needs its own permissions. Per-user only, no role holds it.
  ACTIVITY_BADGES: 'ACTIVITY_BADGES',
  // CON-1597 — Value Lists (reusable dropdown option sets). SIDEBAR shows
  // the "Lists" nav item only; MANAGE gates the Lists page, own-list CRUD,
  // and Save as List; ADMIN_VALUE_LISTS_EDIT shows the scope selector and
  // company picker on the list detail page.
  VALUE_LISTS_SIDEBAR: 'VALUE_LISTS_SIDEBAR',
  VALUE_LISTS_MANAGE: 'VALUE_LISTS_MANAGE',
  ADMIN_VALUE_LISTS_EDIT: 'ADMIN_VALUE_LISTS_EDIT',
  // CON-1608 — Import Templates. VIEW gates whether templates surface at
  // all (picker + detection + apply); MANAGE gates save/update/delete of
  // own templates from the import flow; ADMIN_..._EDIT shows the scope
  // selector on save (universal/company templates). VIEW and MANAGE are
  // independent — check both.
  IMPORT_TEMPLATES_VIEW: 'IMPORT_TEMPLATES_VIEW',
  IMPORT_TEMPLATES_MANAGE: 'IMPORT_TEMPLATES_MANAGE',
  ADMIN_IMPORT_TEMPLATES_EDIT: 'ADMIN_IMPORT_TEMPLATES_EDIT',
  // Volume Discount
  TEXTING_VOLUME_DISCOUNT: 'TEXTING_VOLUME_DISCOUNT',
  // Bulk Birthday Modify
  CONTACTS_BIRTHDAY_MODIFY_BULK: 'CONTACTS_BIRTHDAY_MODIFY_BULK',
  // Smart Compose
  SMART_COMPOSE_VIEW: 'SMART_COMPOSE_VIEW',
  // Test Deliverability
  TEST_DELIVERABILITY_VIEW: 'TEST_DELIVERABILITY_VIEW',
  // Report Not Delivered
  REPORT_NOT_DELIVERED_VIEW: 'REPORT_NOT_DELIVERED_VIEW',
  // What's New
  WHATS_NEW_VIEW: 'WHATS_NEW_VIEW',
  // Phone Textable Override
  PHONE_TEXTABLE_OVERRIDE: 'PHONE_TEXTABLE_OVERRIDE',
  // Bulk Modify Contacts
  BULK_MODIFY_CONTACTS: 'BULK_MODIFY_CONTACTS',
  // Messaging Settings - General Tab
  MESSAGING_SETTINGS_GENERAL_VIEW: 'MESSAGING_SETTINGS_GENERAL_VIEW',
  MESSAGING_SETTINGS_DAILY_LIMIT_INCREASE: 'MESSAGING_SETTINGS_DAILY_LIMIT_INCREASE',
  MESSAGING_SETTINGS_PERMANENT_LIMIT_CHANGE: 'MESSAGING_SETTINGS_PERMANENT_LIMIT_CHANGE',
  // Event Templates (CON-1487)
  EVENT_TEMPLATES_VIEW: 'EVENT_TEMPLATES_VIEW',
  HOST_CAN_INVITE_VIA_CONSULTANT_SMS_VIEW: 'HOST_CAN_INVITE_VIA_CONSULTANT_SMS_VIEW',
  HOST_HAS_TEXTING_OPTIONS_VIEW: 'HOST_HAS_TEXTING_OPTIONS_VIEW',
  HOST_HAS_EMAIL_OPTIONS_VIEW: 'HOST_HAS_EMAIL_OPTIONS_VIEW',
  HOST_CAN_INVITE_VIA_OTHER_VIEW: 'HOST_CAN_INVITE_VIA_OTHER_VIEW',
  EVENT_TEMPLATE_DEFAULTS_ADMIN: 'EVENT_TEMPLATE_DEFAULTS_ADMIN',
  // Host Templates v2 — gates the whole authoring surface (Edit Categories,
  // per-template Start/End day offsets + Active toggle, custom create/delete).
  EDIT_HOST_TEMPLATE_SETTINGS: 'EDIT_HOST_TEMPLATE_SETTINGS',
  // CON-1576 — gates the "Host Welcome Video URL" input on the Event
  // Templates tab configuration band (both Event and Event Type scope).
  EDIT_HOST_APP_WELCOME_VIDEO: 'EDIT_HOST_APP_WELCOME_VIDEO',
  // CON-1532 Phase 9 — Page Column Defaults admin page (company-tier defaults
  // for the three V2 pageKeys). AND-gated with ADMIN_TOOLS_VIEW on the route
  // + sidebar entry.
  PAGE_COLUMN_DEFAULTS_ADMIN: 'PAGE_COLUMN_DEFAULTS_ADMIN',
  // CON-1488 — Admin TCR Registrations list page. Read-only cross-salesperson
  // view used to locate stuck or rejected TCR registrations. AND-gated with
  // ADMIN_TOOLS_VIEW on the route + sidebar entry.
  TCR_REGISTRATIONS_ADMIN: 'TCR_REGISTRATIONS_ADMIN',
  // Admin tools umbrella (CON-1487 Phase G)
  ADMIN_TOOLS_VIEW: 'ADMIN_TOOLS_VIEW',
  // CON-1552 — Share Center (Share Sets; user-facing name "Sets").
  // SIDEBAR gates the nav item; VIEW gates the Share Center page, the
  // universal share-code entry box, and the identify endpoint (the
  // apply-rollout wave grants SIDEBAR + VIEW); MANAGE gates all Sets UI
  // (My Sets, Create, Set detail, Add Items).
  SHARE_SETS_SIDEBAR: 'SHARE_SETS_SIDEBAR',
  SHARE_SETS_VIEW: 'SHARE_SETS_VIEW',
  SHARE_SETS_MANAGE: 'SHARE_SETS_MANAGE',
  // CON-1552 — the two-gate subscription opt-in model (fail-closed).
  // CREATE_SUBSCRIPTION shows the author the "make this a subscription"
  // toggle; CAN_SUBSCRIBE shows the recipient the "receive future updates"
  // checkbox at apply.
  SHARE_SETS_CREATE_SUBSCRIPTION: 'SHARE_SETS_CREATE_SUBSCRIPTION',
  SHARE_SETS_CAN_SUBSCRIBE: 'SHARE_SETS_CAN_SUBSCRIBE',
  // Referral onboarding share set, dark-launch gate: the "Offer to my
  // referrals" checkbox, the Referral set chip and the unpublished-changes
  // warning show only with it (the server enforces it on marking too).
  SHARE_SETS_REFERRAL_ONBOARDING: 'SHARE_SETS_REFERRAL_ONBOARDING',
  // CON-1552 — per-entity sharing gates (dark; seeded isActive=false for
  // every role, granted per-user). SHARE_KEYWORDS gates the keyword apply-
  // share-code button and the keyword Share Code column; SHARE_GROUPS gates
  // the group apply-share-code button, the group Share Code column/field, and
  // the group Duplicate controls (list kebab + detail page).
  SHARE_KEYWORDS: 'SHARE_KEYWORDS',
  SHARE_GROUPS: 'SHARE_GROUPS',
  // CON-1625 — per-entity sharing gates for the two template types that
  // share the followUpMessageDefs table (dark; seeded isActive=false for
  // every role, granted per-user). SHARE_MESSAGE_TEMPLATES gates the
  // Message Templates (usr) apply-share-code button, Share Code column, and
  // Duplicate kebab. SHARE_FOLLOWUP_TEMPLATES gates the Order Follow-Up
  // (msg/default) Share Code column and apply button; follow-ups apply by
  // REPLACE, never copy, so that surface has no Duplicate control.
  SHARE_MESSAGE_TEMPLATES: 'SHARE_MESSAGE_TEMPLATES',
  SHARE_FOLLOWUP_TEMPLATES: 'SHARE_FOLLOWUP_TEMPLATES',
  // CON-1698 — Setup Assistant. ONE code gates the sidebar entry
  // (NavBar/options.js), the /app/setup-assistant route guard (Routes.js),
  // and every /api/setup-assistant route. There is deliberately no
  // SETUP_ASSISTANT_SIDEBAR. The CP-texting test (textingProvider === 'CP')
  // still applies alongside it — both must hold. Seeded isActive=false for
  // every role, granted per-user.
  SETUP_ASSISTANT: 'SETUP_ASSISTANT',
  // CON-1925 — multi-attachment outbound MMS beta. With it (and CP texting)
  // the Connections composer, its scheduled-message edit modal and bulk
  // SEND TEXT accept up to account.mmsAttachmentPolicy.maxAttachments files
  // on one text. Without it every surface stays at one attachment. Seeded
  // isActive=false for every role, granted per-user. Checked through
  // helpers/permissions.canSendMultipleAttachments.
  MULTI_ATTACHMENT_MMS: 'MULTI_ATTACHMENT_MMS',
  // CON-1963 — Sign In As. On for the Admin and Support roles, plus a
  // per-user grant on the shared support account. Admin-role accounts get
  // the forced dialog; every other holder gets "Sign In As" in the account
  // menu (layouts/DashboardLayout/TopBar/Account.js). The server checks it
  // on /api/account/signInAsUser and /api/account/accountlist.
  SIGN_IN_AS: 'SIGN_IN_AS',
};
